export const GET_POLICY_DOCUMENTS_API_REQUEST = 'GET_POLICY_DOCUMENTS_API_REQUEST';
export const GET_POLICY_DOCUMENTS_API_SUCCESS = 'GET_POLICY_DOCUMENTS_API_SUCCESS';
export const GET_POLICY_DOCUMENTS_API_ERROR = 'GET_POLICY_DOCUMENTS_API_ERROR';

export const DOWNLOAD_POLICY_DOCUMENT_API_REQUEST = 'DOWNLOAD_POLICY_DOCUMENT_API_REQUEST';
export const DOWNLOAD_POLICY_DOCUMENT_API_SUCCESS = 'DOWNLOAD_POLICY_DOCUMENT_API_SUCCESS';
export const DOWNLOAD_POLICY_DOCUMENT_API_ERROR = 'DOWNLOAD_POLICY_DOCUMENT_API_ERROR';